import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  AddSearchIcon,
  Download,
  EditIcon,
  ExpandIcon,
  DownloadIconTwo,
  UploadIcon,
  InvoiceIcon,
} from '../../components/icons';
import { TitleNumber, DetailWrapDesktop, OrderDetailsButton } from './styles';
import SidebarSummary from './SidebarSummary';
import { Order, Property, Search } from '../types';
import Priority from './Priority';
import Button from '../../components/Button';
import AddSearchModal from './add-search-modal';
import { useUserContext } from '../../context/UserContext';
import { MdOutlineAddBox, MdAddBusiness } from 'react-icons/md';
import { PlusIcon } from '../OrderEntry/ui/icons';
import AddPropertyModal from '../OrderDetails/AddProperty/AddPropertyModal';
import { OrderContinModal } from './OrderContin/OrderContinModal';
import { PropertyWithSearchesForContin } from './OrderContin/types';

interface Props {
  order: Order;
  download: (merge: boolean) => void;
  getPriority: () => string;
  setPriority: (priority: string) => void;
  showDownload?: boolean;
  getOrderDetails?: () => Promise<void>;
  searchesToDownload: number[];
}
const OrderSummary = (props: Props) => {
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [sidebarSummaryOpen, setSidebarSummaryOpen] = useState(false);
  const [openAddSearch, setOpenAddSearch] = useState(false);
  const [openAddProperty, setOpenAddProperty] = useState(false);
  const [openOrderContin, setOpenOrderContin] = useState(false);
  const [propertiesWithSearchesForContin, setPropertiesWithSearchesForContin] = useState<
    PropertyWithSearchesForContin[]
  >([]);
  const { user } = useUserContext();
  const history = useHistory();

  useEffect(() => {
    window.addEventListener('click', () => {
      setDownloadOpen(false);
      setEditOpen(false);
    });
    return () => {
      window.removeEventListener('click', () => {
        setDownloadOpen(false);
        setEditOpen(false);
      });
    };
  }, []);

  useEffect(() => {
    if (props.order?.properties) {
      setPropertiesWithSearchesForContin(getPropertiesWithSearchesForContin());
    }
  }, [props.order.properties]);

  const getPropertiesWithSearchesForContin = () => {
    return props.order.properties
      .map(p => {
        return {
          propertyId: p.id,
          propertyAddress: p.address,
          sbl: `${p.section ? `${p.section}-` : ''}${p.block}-${p.lot}`,
          orderId: props.order.id,
          titleNumber: props.order.titleNumber,
          searchesForContin: p.searches
            .filter(s => {
              var latestOfSearchType = getLatestSearch(p, s);
              return (
                s.searchStatusType == 'Completed' &&
                (!s.continOrUpdateNumber || s.continOrUpdateNumber == 0) &&
                latestOfSearchType.searchStatusType === 'Completed'
              );
            })
            .map(s => {
              var latestOfSearchType = getLatestSearch(p, s);
              var sixMonthsAgo = new Date();
              sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
              var latestSearchDateAdded = new Date(latestOfSearchType.dateAdded);
              return {
                searchId: s.id,
                searchType: s.searchType,
                searchTypeId: s.searchTypeId,
                propertyId: p.id,
                sixMonthsSinceLastSearch: latestSearchDateAdded <= sixMonthsAgo,
              };
            }),
        };
      })
      .filter(p => p.searchesForContin.length > 0);
  };

  const getLatestSearch = (p: Property, s: Search) => {
    var allSearchesOfSameSearchType = p.searches.filter(search => search.searchTypeId === s.searchTypeId);
    return allSearchesOfSameSearchType.length === 1
      ? allSearchesOfSameSearchType[0]
      : allSearchesOfSameSearchType.reduce((prev, current) => {
          return prev.continOrUpdateNumber > current.continOrUpdateNumber ? prev : current;
        });
  };

  const onCloseAddContin = () => {
    setOpenOrderContin(false);
    props.getOrderDetails();
  };

  return (
    <>
      <DetailWrapDesktop>
        {sidebarSummaryOpen && <Overlay onClick={() => setSidebarSummaryOpen(false)} />}
        <div className="flex aic full-width jcsb wrap">
          {/* <TitleNumber>{props.order.titleNumber}</TitleNumber> */}
          <div className="flex">
            {props.showDownload && (
              <div style={{ position: 'relative', cursor: 'pointer' }}>
                <Button
                  onClick={(e: MouseEvent) => {
                    e.stopPropagation();
                    setDownloadOpen(!downloadOpen);
                  }}
                  buttonType={
                    props.searchesToDownload.length === 0
                      ? 'ButtonSecondarySmallDisabled'
                      : 'ButtonSecondarySmall'
                  }
                  buttonText="Download"
                  icon={<DownloadIconTwo />}
                />
                {downloadOpen && (
                  <DownloadOptions>
                    <div
                      style={{
                        color: '#93918F',
                        fontSize: 12,
                        textTransform: 'uppercase',
                      }}
                    >
                      Download
                    </div>
                    <DownloadOptionStyles onClick={() => props.download(false)}>
                      Download Individual Documents
                    </DownloadOptionStyles>
                    <DownloadOptionStyles onClick={() => props.download(true)}>
                      Merge Documents & Download
                    </DownloadOptionStyles>
                  </DownloadOptions>
                )}
              </div>
            )}
            {props.order.statusId !== 3 && (
              <>
                <Button
                  onClick={() => setOpenAddSearch(true)}
                  buttonType="ButtonSecondarySmall"
                  buttonText="Add Search"
                  icon={<MdOutlineAddBox />}
                />
              </>
            )}
            <Button
              onClick={() => setOpenAddProperty(true)}
              buttonType="ButtonSecondarySmall"
              buttonText="Add Property"
              icon={<MdAddBusiness />}
              width={'130px'}
            />
            <div style={{ position: 'relative' }}>
              <Button
                onClick={(e: MouseEvent) => {
                  e.stopPropagation();
                  setEditOpen(!editOpen);
                }}
                buttonType="ButtonSecondarySmall"
                buttonText="Change Priority"
                icon={<EditIcon stroke="#444340" />}
                width={200}
              />
              {editOpen && (
                <EditOptions>
                  {/* <div
                    style={{
                      color: '#93918F',
                      fontSize: 12,
                      textTransform: 'uppercase',
                    }}
                  >
                    Change Priority
                  </div> */}
                  <Priority priority={props.getPriority()} onChange={props.setPriority} />
                </EditOptions>
              )}
            </div>
            <Button
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
                history.push(
                  `/billingStatement/${props.order.id}/${props.order.titleNumber?.replace('/', '-')}`
                );
              }}
              buttonType="ButtonSecondarySmall"
              buttonText="View Billing Statement"
              icon={<InvoiceIcon stroke="#444340" />}
              width={'200px'}
            />
            <Button
              onClick={() => setOpenOrderContin(true)}
              buttonType={
                propertiesWithSearchesForContin.length > 0
                  ? 'ButtonGreenSmall'
                  : 'ButtonSecondarySmallDisabled'
              }
              buttonText="Order Contins/Updates"
              icon={<MdOutlineAddBox />}
              width={'200px'}
            />
          </div>

          {props.order.statusId === 2 && (
            <div className="flex aic relative ml2">
              <OnHoldCancelled>On Hold</OnHoldCancelled>
            </div>
          )}
          {props.order.statusId === 3 && (
            <div className="flex aic relative ml2">
              <OnHoldCancelled>Cancelled</OnHoldCancelled>
            </div>
          )}
          <OrderDetailsButton onClick={() => setSidebarSummaryOpen(true)}>
            Order Details
            <ExpandIcon />
          </OrderDetailsButton>
        </div>
        <SidebarStyles
          style={sidebarSummaryOpen ? { width: 498, overflow: 'auto', transition: 'all .2s' } : {}}
        >
          {props.order && sidebarSummaryOpen && (
            <SidebarSummary
              onClick={() => setSidebarSummaryOpen(false)}
              order={props.order}
              status={props.getPriority()}
            />
          )}
        </SidebarStyles>
      </DetailWrapDesktop>
      {openAddSearch && (
        <AddSearchModal
          open={openAddSearch}
          onClose={() => {
            setOpenAddSearch(false);
            props.getOrderDetails && props.getOrderDetails();
          }}
          properties={props.order.properties}
          clientName={props.order.clientName}
          orderId={props.order.id}
          userId={user.id}
          titleNumber={props.order.titleNumber}
          userName={`${user.firstName || ''} ${user.lastName || ''}`}
        />
      )}
      {openAddProperty && (
        <AddPropertyModal
          open={openAddProperty}
          onClose={() => setOpenAddProperty(false)}
          order={props.order}
          getOrderDetails={() => props.getOrderDetails()}
        />
      )}
      {openOrderContin && (
        <OrderContinModal
          open={openOrderContin}
          properties={propertiesWithSearchesForContin}
          onClose={onCloseAddContin}
        />
      )}
    </>
  );
};

export default OrderSummary;

const DownloadOptions = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #e5e5ea;
  padding: 24px 40px 24px 24px;
  left: 0;
  top: 40px;
  width: 237px;
  z-index: 50;
  border-radius: 4px;
`;
const DownloadOptionStyles = styled.div`
  margin-top: 8px;
  font-size: 16px;
  cursor: pointer;
  color: #444340;
  :hover {
    color: #bcc2c7;
  }
`;
const EditOptions = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #eae8e5;
  border-radius: 4px;
  padding: 24px 40px 24px 24px;
  left: 0px;
  top: 48px;
  width: 175px;
  z-index: 50;
`;
const SidebarStyles = styled.div`
  background-color: #fff;
  box-shadow: 0px 16px 32px #eae8e5;
  height: 100vh;
  max-width: 90vw;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
  transition: all 0.2s ease;
  width: 0;
  z-index: 90000;
`;
const Overlay = styled.div`
  background-color: rgba(233, 232, 232, 0.5);
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10000;
`;
const OnHoldCancelled = styled.div`
  color: #e52c2c;
  display: flex;
  align-items: center;
  /* position: absolute;
  left: 204px; */
  z-index: 50;
`;
